import { useState, useEffect } from 'react'
import { isReactNativeWebView } from 'utilities/react-native'

const useIsReactNativeWebView = () => {
  const [clientSide, setClientSide] = useState(false)

  useEffect(() => {
    setClientSide(true)
  }, [])

  if (!clientSide) return null
  else return isReactNativeWebView()
}

export default useIsReactNativeWebView
